import { render, staticRenderFns } from "./FooterP.vue?vue&type=template&id=189134a2&scoped=true"
import script from "./FooterP.vue?vue&type=script&lang=js"
export * from "./FooterP.vue?vue&type=script&lang=js"
import style0 from "./FooterP.vue?vue&type=style&index=0&id=189134a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189134a2",
  null
  
)

export default component.exports